<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				<img src="../../assets/budget/fanhui.png" @click="Return"
					style="vertical-align: middle;margin-top: -2px;" />
				进场测算管理-新增
			</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="height:20px"></div>
				<div class="findcontent">
					<div class="findTitle">测算单</div>
					<div class="formlist" style="margin-left: 10px;">
						<el-form :inline="true" :model="formInline" class="demo-form-inline">
							<el-form-item label="测算单编号">
								<el-input v-model="formInline.budget_number" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
							<el-form-item label="年度">
								<el-date-picker v-model="formInline.annual" type="year" value-format="yyyy"
									placeholder="选择年" size="small" style="width:120px" @input="changeInput()">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="测算日期">
								<el-date-picker v-model="formInline.calculation_date" type="date" value-format="yyyy-MM-dd"
									size="small" style="width:150px">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="项目名称">
								<el-select v-model="formInline.project_id" clearable style="width:160px"
									@input="changeInput()" @change="proClick" size="small" filterable>
									<el-option v-for="item in projectList" :key="item.id" :label="item.organize_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="组织架构">
								<el-input v-model="formInline.group_structure" style="width:160px" size="small">
								</el-input>
							</el-form-item>
							<el-form-item label="申购人">
								<el-input v-model="formInline.requisitioner" style="width:150px" size="small"
									@input="changeInput()">
								</el-input>
							</el-form-item>
							<el-form-item label="到货时间">
								<el-date-picker v-model="formInline.arrival_time" type="date" value-format="yyyy-MM-dd"
									size="small" style="width:150px" @input="changeInput()">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="收货人" label-width="90px">
								<el-input v-model="formInline.consignee" style="width:150px" size="small"
									@input="changeInput()"></el-input>
							</el-form-item>
							<el-form-item label="联系方式">
								<el-input v-model="formInline.contact_information" style="width:150px" size="small"
									@input="changeInput()"></el-input>
							</el-form-item>
							<el-form-item label="进场日期">
								<el-date-picker v-model="formInline.entry_date" type="date" value-format="yyyy-MM-dd"
									size="small" style="width:150px" @input="changeInput()">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="备注">
								<el-input v-model="formInline.notes" style="width:160px" size="small"
									@input="changeInput()"></el-input>
							</el-form-item>
							<el-form-item label="制表人">
								<el-input v-model="formInline.tabulator" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div class="btnicon">
					<div class="btnview" @click="Save()">
						<img src="../../assets/budget/保存.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">保存</span>
					</div>
					<div class="btnview">
						<img src="../../assets/budget/提交审核.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">提交审核</span>
					</div>
					<div class="btnview">
						<img src="../../assets/budget/导出.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">导出</span>
					</div>
				</div>

				<div class="tabs">
					<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="预算汇总表" name="firstOne">
							<div>
								<el-table :data="tableDataOne" ref="multipleTable"
									:header-cell-style="{ background: '#d3eae2', color: '#000000' }" border
									@selection-change="handleSelectionChange" style="width: 100%" height="480">
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="firstName" align="center" label="预算分类"></el-table-column>
									<el-table-column prop="accumulate_1" align="center" label="1月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_1" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_1 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_2" align="center" label="2月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_2" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_2 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_3" align="center" label="3月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_3" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_3 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_4" align="center" label="4月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_4" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_4 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_5" align="center" label="5月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_5" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_5 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_6" align="center" label="6月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_6" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_6 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_7" align="center" label="7月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_7" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_7 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_8" align="center" label="8月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_8" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_8 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_9" align="center" label="9月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_9" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_9 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_10" align="center" label="10月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_10" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_10 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_11" align="center" label="11月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_11" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_11 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_12" align="center" label="12月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_12" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@keyup.enter.native="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_12 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate" align="center" label="合计"></el-table-column>

								</el-table>
							</div>
						</el-tab-pane>
						<el-tab-pane label="预算表" name="firstTwo">
							<div>
								<!-- :span-method="objectSpanMethod" @cell-mouse-enter="cellMouseEnter" -->
								<el-table :data="tableDataTwo" ref="multipleTable"
									:header-cell-style="{ background: '#d3eae2', color: '#000000' }" border
									@selection-change="handleSelectionChange" style="width: 100%"
									@cell-mouse-leave="cellMouseLeave" :key="changeKey" :summary-method="getSummaries"
									height="480" :cell-class-name="tableRowClassName">
									<!-- <el-table-column align="center" label="" width="50">
										<template slot-scope="scope">
											<img src="../../assets/budget/新增预算.png" @click="budClick(scope.row)"
												style="vertical-align: middle;margin-top:-2px" />
										</template>
									</el-table-column> -->
									<el-table-column prop="series" align="center" label="预算分类" width="150" fixed>
										<template slot-scope="scope">
											<span>{{ scope.row.first_name }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="secondary_name" align="center" label="预算名称" width="200" fixed>
									</el-table-column>
									<el-table-column prop="invoice_name" align="center" v-for="(item, index) in dateList"
										:key="index" width="150">
										<template slot="header" slot-scope="scope">
											<span>{{ item.monthly }}月月度预算</span>
											<img src="../../assets/budget/复制.png" @click="dateClick(item.monthly)"
												style="vertical-align: middle;margin-top:-2px" />
										</template>
										<el-table-column align="center" label="在岗人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].employees_number"
													size="small" class="table"
													@keyup.enter.native="updateData($event, index, scope.row)">
												</el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="倒休人数">
											<template slot-scope="scope" ref="loginForm">
												<el-input v-model="scope.row.outsideList[index].retroactive_rest"
													class="table" size="small"
													@keyup.enter.native="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="合计人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].amount_number" class="table"
													size="small"
													@keyup.enter.native="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="单人金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].individual_amount"
													class="table" size="small"
													@keyup.enter.native="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="总金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].assemble_amount"
													class="table" size="small"
													@keyup.enter.native="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
									</el-table-column>
								</el-table>
							</div>
							<el-dialog title="新增预算" v-if="budShow" :visible.sync="budShow" width="30%" center="true"
								:close-on-click-modal="false">
								<div>
									<el-checkbox-group v-model="budLists" @change="handleCheckedbudChange"
										style="margin-bottom: 15px;margin-left: 15%;">
										<el-checkbox v-for="item in budList" :label="item.id" :key="item.id"
											style="margin-bottom: 20px;width: 40%;">
											{{ item.secondary_category }}
										</el-checkbox>
									</el-checkbox-group>
									<div style="text-align: center;">
										<el-button type="goon" @click="AddSavebud()">保存</el-button>
									</div>
								</div>
							</el-dialog>
							<el-dialog title="选择月份" :visible.sync="dateShow" width="30%" center="true"
								:close-on-click-modal="false">
								<div>
									<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange"
										style="margin-bottom: 20px;">
										<el-checkbox v-for="(item, index) in dates" :label="item.id" :key="index"
											style="margin-bottom: 20px;">
											{{ item.date }}
										</el-checkbox>
									</el-checkbox-group>
									<div style="text-align: center;">
										<el-button type="goon" @click="AddSaveDate()">保存</el-button>
									</div>
								</div>
							</el-dialog>
						</el-tab-pane>
						<el-tab-pane label="物料明细表" name="firstThree">
							<div>
								<!-- <div class="btnicons">
									<div class="btnview" @click="addtableThree()">
										<img src="../../assets/budget/新增11.png" style="vertical-align: middle;margin-top: -3px;" />
										<span style="font-size: 17px;">新增</span>
									</div>
									<div class="btnview" @click="AddThree()">
										<img src="../../assets/budget/保存.png" style="vertical-align: middle;margin-top: -3px;" />
										<span style="font-size: 17px;">保存</span>
									</div>
								</div> -->
								<el-table :header-cell-style="{ background: '#d4e9e2', color: '#000000' }"
									:row-class-name="tableRowClassName" ref="multipleTable" :data="tableDataThree"
									tooltip-effect="dark" style="width: 100%;" height="415"
									@selection-change="handleSelectionChange" border>
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="name" align="center" label="名称"></el-table-column>
									<el-table-column prop="model" align="center" label="型号"></el-table-column>
									<el-table-column prop="unity" align="center" label="单位"></el-table-column>
									<el-table-column prop="accumulate" align="center" label="数量">
										<template slot-scope="scope">
											<el-input v-model="scope.row.number" size="small"
												@keyup.enter.native="updateDataThree($event, index, scope.row)"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="unit_price" align="center" label="单价"></el-table-column>
									<el-table-column prop="amount_money" align="center" label="金额"></el-table-column>
									<el-table-column prop="notes" align="center" label="备注"></el-table-column>
								</el-table>
							</div>
						</el-tab-pane>
						<el-tab-pane label="固定资产明细表" name="firstFout">
							<div>
								<!-- <div class="btnicons">
									<div class="btnview" @click="addtableFour()">
										<img src="../../assets/budget/新增11.png" style="vertical-align: middle;margin-top: -3px;" />
										<span style="font-size: 17px;">新增</span>
									</div>
									<div class="btnview" @click="AddFour()">
										<img src="../../assets/budget/保存.png" style="vertical-align: middle;margin-top: -3px;" />
										<span style="font-size: 17px;">保存</span>
									</div>
								</div> -->
								<el-table :header-cell-style="{ background: '#d4e9e2', color: '#000000' }"
									:row-class-name="tableRowClassName" ref="multipleTable" :data="tableDataFour"
									tooltip-effect="dark" style="width: 100%;" height="415"
									@selection-change="handleSelectionChange" border>
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="name" align="center" label="名称"></el-table-column>
									<el-table-column prop="brand" align="center" label="品牌"></el-table-column>
									<el-table-column prop="specification_model" align="center"
										label="规格型号"></el-table-column>
									<el-table-column prop="basic_unit" align="center" label="基本单位"></el-table-column>
									<el-table-column prop="unit_price" align="center" label="单价"></el-table-column>
									<el-table-column prop="accumulate" align="center" label="数量">
										<template slot-scope="scope">
											<el-input v-model="scope.row.number" size="small"
												@keyup.enter.native="updateDataFout($event, index, scope.row)"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="amount_money" align="center" label="金额"></el-table-column>
									<el-table-column prop="notes" align="center" label="备注"></el-table-column>
								</el-table>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	props: ["ruleForm", "projectId"],
	data() {
		return {
			total: 0,
			activeName: 'firstOne',
			dateShow: false,
			budShow: false,
			tableData: [],
			ids: [],
			//条件
			formInline: {},
			dateLists: [],
			budList: [],
			dateList: [{
				monthly: 1
			}, {
				monthly: 2
			}, {
				monthly: 3
			}, {
				monthly: 4
			}, {
				monthly: 5
			}, {
				monthly: 6
			}, {
				monthly: 7
			}, {
				monthly: 8
			}, {
				monthly: 9
			}, {
				monthly: 10
			}, {
				monthly: 11
			}, {
				monthly: 12
			},
			],
			tableDataOne: [],
			tableDataTwo: [],
			budLists: [],
			testList: [],
			tableDataThree: [],
			tableDataFour: [],
			checkedCities: [],
			checkedbuds: [],
			projectList: [],
			orderIndexArr: [],
			hoverOrderArr: [],
			dates: [{
				id: 1,
				date: '一月'
			}, {
				id: 2,
				date: '二月'
			}, {
				id: 3,
				date: '三月'
			}, {
				id: 4,
				date: '四月'
			}, {
				id: 5,
				date: '五月'
			}, {
				id: 6,
				date: '六月'
			}, {
				id: 7,
				date: '七月'
			}, {
				id: 8,
				date: '八月'
			}, {
				id: 9,
				date: '九月'
			}, {
				id: 10,
				date: '十月'
			}, {
				id: 11,
				date: '十一月'
			}, {
				id: 12,
				date: '十二月'
			}]
		};
	},
	methods: {
		async proClick(val) {
			var data = await this.$globals.AxiosGet("budgetForm/getOrganizeName?info=" + val);
			this.formInline.group_structure = data.data;
		},
		// async Save() {
		// 	this.formInline.spare5 = '2';
		// 	var data = await this.$globals.AxiosPost('calculationSheet/add', this.formInline);
		// 	if (data === '-2000') {
		// 		this.$message.error('服务器未响应！请稍后重试');
		// 	} else {
		// 		var code = data.code;
		// 		var data = data.data;
		// 		if (code === '200') {
		// 			this.$message.success(data);
		// 			setTimeout(()=> {
		// 				this.$emit("return");
		// 			},1000)
		// 		} else {
		// 			this.$message.warning('请求失败！请稍后重试');
		// 		}
		// 	}
		// },

		async Save() {
			this.formInline.spare5 = '2';
			var data = await this.$globals.AxiosPost('budgetForm/update', this.formInline);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		handleClick(tab, event) {
			if (tab.name == 'firstOne') {
				this.FindOne()
			} else if (tab.name == 'firstTwo') {
				this.FindTwo()
			} else if (tab.name == 'firstThree') {
				this.FindThree()
			} else {
				this.FindFout()
			}

		},
		async changeInput() {
			var record = {
				id: this.formInline.id,
				budget_number: this.formInline.budget_number,
				annual: this.formInline.annual,
				project_id: this.formInline.project_id,
				group_structure: this.formInline.group_structure,
				notes: this.formInline.notes,
				tabulator: this.formInline.tabulator,
				calculation_date: this.formInline.calculation_date,
				arrival_time: this.formInline.arrival_time,
				requisitioner: this.formInline.requisitioner,
				entry_date: this.formInline.entry_date,
				contact_information: this.formInline.contact_information,
				consignee: this.formInline.consignee,
				spare5: '2',
			}
			var data = await this.$globals.AxiosPost('budgetForm/updateBudget', record);
			if (data.code === '200') {
				console.log(11111)
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		async Find() {
			var data = await this.$globals.AxiosGet("budgetForm/generateCode");
			this.formInline = data.data;
			this.tableDataOne = data.data.summaryList;
			this.tableDataTwo = data.data.outsideDtoList;
		},
		async FindOne() {
			var data = await this.$globals.AxiosGet("formSummary/getSummaryList?info=" + this.formInline.id);
			this.tableDataOne = data.data;
		},
		async FindTwo() {
			var data = await this.$globals.AxiosGet('budgetForm/getOutsideList?info=' + this.formInline.id);
			if (data.code === '200') {
				this.tableDataTwo = data.data;
				this.getOrderNumber()
				this.changeKey = !this.changeKey;
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		async FindThree() {
			var data = await this.$globals.AxiosGet("budgetForm/getCityMaterial?info=" + this.formInline.id);
			this.tableDataThree = data.data;
		},
		async FindFout() {
			var data = await this.$globals.AxiosGet('budgetForm/getCityAsset?info=' + this.formInline.id);
			this.tableDataFour = data.data;
		},
		async updateDataOne(event, index, row) {
			var record = {
				budget_id: this.formInline.id,
				first_id: row.first_id,
				accumulate_1: row.accumulate_1,
				accumulate_2: row.accumulate_2,
				accumulate_3: row.accumulate_3,
				accumulate_4: row.accumulate_4,
				accumulate_5: row.accumulate_5,
				accumulate_6: row.accumulate_6,
				accumulate_7: row.accumulate_7,
				accumulate_8: row.accumulate_8,
				accumulate_9: row.accumulate_9,
				accumulate_10: row.accumulate_10,
				accumulate_11: row.accumulate_11,
				accumulate_12: row.accumulate_12,
			}
			var data = await this.$globals.AxiosPost('formSummary/updateSummary', record);
			if (data.code === '200') {
				if (event) {
					event.target.blur()
				}
				this.$message.success('修改成功！');
				this.FindOne()
				this.$refs["loginForm"].$el[index + 1].focus();
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},

		async updateDataThree(event, index, row) {
			var record = {
				id: row.id,
				sheet_id: this.formInline.id,
				name: row.name,
				brand: row.brand,
				specification_model: row.specification_model,
				basic_unit: row.basic_unit,
				unit_price: row.unit_price,
				number: row.number,
				amount_money: row.amount_money,
				notes: row.notes
			}
			var data = await this.$globals.AxiosPost('budgetForm/updateCityMaterial', record);
			if (data.code === '200') {
				if (event) {
					event.target.blur()
				}
				this.$message.success('修改成功！');
				this.FindThree()
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},

		async updateDataFout(event, index, row) {
			var record = {
				sheet_id: this.formInline.id,
				id: row.id,
				name: row.name,
				model: row.model,
				unity: row.unity,
				number: row.number,
				amount_money: row.amount_money,
				unit_price: row.unit_price,
				notes: row.notes
			}
			var data = await this.$globals.AxiosPost('budgetForm/updateCityAsset', record);
			if (data.code === '200') {
				if (event) {
					event.target.blur()
				}
				this.$message.success('修改成功！');
				this.FindFout()
				this.$refs["loginForm"].$el[index + 1].focus();
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},

		async updateData(event, index, row) {
			var record = {
				budget_id: this.formInline.id,
				first_id: row.first_id,
				secondary_id: row.secondary_id,
				monthly: row.outsideList[index].monthly,
				employees_number: row.outsideList[index].employees_number,
				retroactive_rest: row.outsideList[index].retroactive_rest,
				amount_number: row.outsideList[index].amount_number,
				individual_amount: row.outsideList[index].individual_amount,
				assemble_amount: row.outsideList[index].assemble_amount,
			}
			var data = await this.$globals.AxiosPost('formOutside/add', record);
			if (data.code === '200') {
				if (event) {
					event.target.blur()
				}
				this.$message.success('修改成功！');
				this.FindTwo()
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		Return() {
			this.$emit("return");
		},
		// 新增预算
		async budClick(e) {
			//
			console.log(this.checkedbuds)
			this.budRow = e;
			var data = await this.$globals.AxiosGet('BudgetSecondary/getList?info=' + e.first_id);
			if (data.code === '200') {
				// this.checkedbuds = [];
				this.budShow = true;
				this.budList = data.data;
				console.log(this.testList)
				let arr = this.testList.find(item => item.first_id == e.first_id)
				this.budLists = arr ? arr.check : []
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		handleCheckedbudChange(value) {
			this.budLists = value
		},
		async AddSavebud() {
			var data = await this.$globals.AxiosPost('budgetForm/adjust', {
				ids: this.budLists,
				budget_id: this.budRow.budget_id,
				first_id: this.budRow.first_id,
			});
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				if (data.code === '200') {
					this.$message.success('保存成功！');
					this.budShow = false;
					console.log(this.testList)
					let arr = this.testList.find(item => item.first_id == this.budRow.first_id)
					if (arr) {
						this.testList.forEach(item => {
							item.check = this.budLists
						})
					} else {
						this.testList.push({
							check: this.budLists,
							first_id: this.budRow.first_id
						})
					}
					this.FindTwo();
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			};
		},
		// 选择日期
		dateClick(e) {
			this.checkedCities = [];
			this.dateNum = e;
			this.dateShow = true
		},
		handleCheckedCitiesChange(value) {
			this.dateLists = value
		},
		async AddSaveDate() {
			var content = {
				budget_id: this.formInline.id,
				monthly: this.dateNum,
				ids: this.dateLists
			}
			var data = await this.$globals.AxiosPost('formOutside/cover', content);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success('修改成功！');
					this.dateShow = false;
					this.FindTwo()
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}


		},
		// 物料明细表
		addtableThree() {
			const newLine = {
				name: '',
				model: '',
				unity: '',
				number: '',
				amount_money: '',
				unit_price: '',
				notes: '',
			}
			this.index++
			this.tableDataThree.push(newLine)
		},
		async AddThree() {
			var record = {
				sheet_id: this.formInline.id,
				materialList: this.tableDataThree,
			}
			var data = await this.$globals.AxiosPost('calculationSheetMaterial/listInsert', record);
			if (data.code === '200') {
				this.$message.success('保存成功！');
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		DelThree(e) {
			if (this.tableDataThree.length != 1) {
				this.tableDataThree.splice(e, 1);
			} else {
				this.$message.warning('请至少保留一条数据！');
			}
		},
		// 固定资产明细表
		addtableFour() {
			const newLine = {
				name: '',
				brand: '',
				specification_model: '',
				basic_unit: '',
				unit_price: '',
				number: '',
				amount_money: '',
				notes: '',
			}
			this.index++
			this.tableDataFour.push(newLine)
		},
		async AddFour() {
			var record = {
				sheet_id: this.formInline.id,
				materialList: this.tableDataFour,
			}
			var data = await this.$globals.AxiosPost('calculationSheetMaterial/listInsert', record);
			if (data.code === '200') {
				this.$message.success('保存成功！');
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		DelFour(e) {
			if (this.tableDataFour.length != 1) {
				this.tableDataFour.splice(e, 1);
			} else {
				this.$message.warning('请至少保留一条数据！');
			}
		},
		// 全选
		handleSelectionChange(e) {
			this.ids = [];
			e.forEach(item => {
				this.ids.push(item.id);
			});
		},
		//分页
		handleCurrentChange(val) {
			this.condition.page_num = val;
		},
		getOrderNumber() {
			const orderObj = {};
			this.tableDataTwo.forEach((item, index) => {
				item.rowIndex = index;
				if (orderObj[item.first_id]) {
					orderObj[item.first_id].push(index);
				} else {
					orderObj[item.first_id] = [];
					orderObj[item.first_id].push(index);
				}
			});
			// 将数组长度大于1的值 存储到this.orderIndexArr（也就是需要合并的项）
			Object.keys(orderObj).forEach((key) => {
				if (orderObj[key].length > 1) {
					this.orderIndexArr.push(orderObj[key]);
				}
			});

			console.log(this.tableDataTwo)

		},
		objectSpanMethod({
			row,
			column,
			rowIndex,
			columnIndex
		}) {
			// if (columnIndex === 0 || columnIndex === 1) {
			// 	for (let i = 0; i < this.orderIndexArr.length; i += 1) {
			// 		let element = this.orderIndexArr[i];
			// 		for (let j = 0; j < element.length; j += 1) {
			// 			let item = element[j];
			// 			if (rowIndex === item) {
			// 				if (j === 0) {
			// 					return {
			// 						rowspan: element.length,
			// 						colspan: 1,
			// 					};
			// 				}
			// 				if (j !== 0) {
			// 					return {
			// 						rowspan: 0,
			// 						colspan: 0,
			// 					};
			// 				}
			// 			}
			// 		}
			// 	}
			// }
		},
		tableRowClassName({
			row,
			rowIndex
		}) {
			let arr = this.hoverOrderArr;
			for (let i = 0; i < arr.length; i += 1) {
				if (rowIndex === arr[i]) {
					return 'hovered-row';
				}
			}
		},
		cellMouseEnter(row, column, cell, event) {
			this.rowIndex = row.rowIndex;
			this.hoverOrderArr = [];
			this.orderIndexArr.forEach((element) => {
				if (element.indexOf(this.rowIndex) >= 0) {
					this.hoverOrderArr = element;
				}
			});
		},
		cellMouseLeave(row, column, cell, event) {
			this.rowIndex = '-1';
			this.hoverOrderArr = [];
		},
	},
	async created() {
		this.formInline = this.ruleForm;
		this.formInline.tabulator = this.$globals.user.name;
		var projectList = await this.$globals.AxiosGet("calculationSheet/getOrganize?info=" + this.projectId);
		this.projectList = projectList.data;
		this.Find();
		this.FindThree();
		this.FindFout();
	},
};
</script>

<style scoped>
.findcontent {
	border: 1px solid #006e4b;
	background-color: #fafff9;
	padding: 10px 0px;
	margin: 0 30px;
}

.findTitle {
	margin-left: 10px;
	font-size: 18px;
	font-weight: 600;
	color: #006e4b;
	margin-top: 10px;
}

.formlist {
	margin-top: 10px
}

.btnicon {
	display: flex;
	margin: 10px 0 10px 10px;
}

.btnicons {
	display: flex;
	margin: 5px 0 10px 10px;
}

.btnview {
	margin-left: 20px;
}

.tabs {
	margin: 0 30px;
}
</style>
<style>
.tabs .el-tabs--border-card>.el-tabs__header {
	background-color: #fafafa;
}

.tabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
	border-top: 3px solid #006e4b;
	font-size: 18px;
	border-right-color: #fff;
	border-left-color: #fff;
}

.tabs .el-tabs--border-card>.el-tabs__header {
	border: none;
}

.tabs .el-tabs--border-card {
	border: none
}

.tabs .el-tabs--border-card>.el-tabs__content {
	padding: 5px 0;
}

.tabs .el-tabs__item {
	font-size: 18px;
}

.tabs .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child {
	font-size: 18px;
}

.tabs .el-tabs__nav {
	height: 40px;
}

.formlist .el-form-item {
	margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// add.vue?492241ac